<template>
  <v-layout column class="pa-2">
    <v-flex grow class="mb-4">
      <v-layout row>
        <v-flex
          v-if="!notSubmittable || newReview.fulfilled"
          grow
          class="headline"
          >Evaluation for {{ newReview.locationName }}</v-flex
        >
      </v-layout>
    </v-flex>

    <v-flex grow>
      <v-layout row>
        <v-flex grow>
          <v-form>
            <div class="mb-4">
              <label class="v-label theme--light" style="left: 0; right: auto; position: relative;">
                Overall clinic rating?
              </label>
              <v-rating
                half-increments hover large length="4" required
                :readonly="notSubmittable"
                v-model="newReview.rating"
              />
            </div>

            <div class="mb-4">
              <label class="v-label theme--light" style="left: 0; right: auto; position: relative;">
                How welcoming was the clinic's team?
              </label>
              <v-rating
                half-increments hover large length="4" required
                :readonly="notSubmittable"
                v-model="newReview.welcomingRating"
              />
            </div>

            <div class="mb-4">
              <label class="v-label theme--light" style="left: 0; right: auto; position: relative;">
                How willing was the clinic team to answer questions and provide guidance when asked?
              </label>
              <v-rating
                half-increments hover large length="4" required
                :readonly="notSubmittable"
                v-model="newReview.guidanceRating"
              />
            </div>

            <div class="mb-4">
              <label class="v-label theme--light" style="left: 0; right: auto; position: relative;">
                How well did the cases/tasks match your skills and experience level?
              </label>
              <v-rating
                half-increments hover large length="4" required
                :readonly="notSubmittable"
                v-model="newReview.skillsMatchRating"
              />
            </div>

            <v-textarea
              v-model="newReview.returnLikelihoodText"
              label="Are you likely to return to this hospital? If not, why?"
              :disabled="notSubmittable"
            />

            <v-textarea
              v-model="newReview.managerNotesText"
              label="What should VSS managers know about this hospital before sending another relief employee?"
              :disabled="notSubmittable"
            />

            <v-layout row justify-space-between>
              <v-flex justify-end class="text-xs-right">
                <div v-if="newReview.fulfilled">
                  <span class="subtle font-italic">Evaluated by {{ newReview.authorName }}</span>
                </div>
                <div v-if="newReview.fulfilled">
                  <span class="subtle font-italic">On {{ newReview.fulfilledAt | moment("dddd, MMM Do") }}</span>
                </div>
                <div>
                  <template v-if="notValid">
                    <v-tooltip top>
                      <v-btn slot="activator" color="success"
                             :loading="posting"
                             :disabled="posting || notSubmittable || notValid"
                             @click="confirmSubmission">Submit</v-btn>
                      <span>You must provide all 4 star ratings</span>
                    </v-tooltip>
                  </template>
                  <template v-else>
                    <v-btn slot="activator" color="success"
                           :loading="posting"
                           :disabled="posting || notSubmittable || notValid"
                           @click="confirmSubmission">Submit</v-btn>
                  </template>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-dialog max-width="400" v-model="confirmDialog">
      <v-card>
        <v-card-title class="headline">
          Are you sure?
        </v-card-title>
        <v-card-text>
          Make sure you are happy with your rating and evaluation. Once you
          submit it you won't be able to change it.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            flat
            color="grey"
            @click="confirmDialog = false"
            :disabled="posting"
            >Nevermind</v-btn
          >
          <v-btn
            @click="updateEvaluation"
            color="success"
            :disabled="posting"
            :loading="posting"
            >I'm Sure</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import {mapState} from 'vuex';

  export default {
    components: {},
    computed: {
      ...mapState('userAuth', ['user']),
      exampleComputed: function() {
        return this.example;
      },
      notSubmittable() {
        // already fulfilled, or couldn't fetch
        if (this.newReview.fulfilled || !this.newReview.hasOwnProperty('id')) {
          return true;
        }
        return false;
      },
      notValid() {
        return (
          !this.newReview.rating ||
          !this.newReview.welcomingRating ||
          !this.newReview.guidanceRating ||
          !this.newReview.skillsMatchRating
        );
      },
    },
    created() {
      this.shareKey = this.$route.params.shareKey;
      this.setUp();
    },
    watch: {},
    data: function() {
      return {
        posting: false,
        shareKey: '',
        newReview: {
          rating: 0.0,
          welcomingRating: 0.0,
          guidanceRating: 0.0,
          skillsMatchRating: 0.0,
          returnLikelihoodText: '',
          managerNotesText: '',
          fulfilled: false,
          authorName: '',
          fulfilledAt: new Date(),
        },
        confirmDialog: false,
      };
    },
    methods: {
      confirmSubmission() {
        this.confirmDialog = true;
      },
      updateEvaluation() {
        this.posting = true;
        this.$store
          .dispatch('clientBusinesses/updateEvaluation', {
            id: this.newReview.id,
            rating: this.newReview.rating,
            welcoming_rating: this.newReview.welcomingRating,
            guidance_rating: this.newReview.guidanceRating,
            skills_match_rating: this.newReview.skillsMatchRating,
            return_likelihood_text: this.newReview.returnLikelihoodText,
            manager_notes_text: this.newReview.managerNotesText,
          })
          .then(res => {
            this.newReview = res;
            this.$store.dispatch(
              'global/showSnackbarSuccess',
              { message: 'Your evaluation has been submitted!' },
              { root: true },
            );
          })
          .catch(err => {
            this.$store.dispatch(
              'global/showSnackbarSuccess',
              { message: 'Something went wrong creating that evaluation...' },
              { root: true },
            );
          })
          .finally(res => {
            this.confirmDialog = false;
            this.posting = false;
          });
      },
      setUp() {
        this.$store
          .dispatch('clientBusinesses/getReviewDraft', this.shareKey)
          .then(res => {
            this.newReview = res;
          });
      },
    },
  };
</script>

<style scoped></style>
